function unsignedNumber(n: number) {
  return n >>> 0;
}

function hexToIp(n: any) {
  return [
    (n >>> 24) & 0xff,
    (n >>> 16) & 0xff,
    (n >>> 8) & 0xff,
    (n >>> 0) & 0xff
  ].join(".");
}
export function isValidCIDR(cidr: any) {
  /* What this Complex Regex Does:
    * ^ start of string
      (?!.*\.$)   Make sure string does not end with a dot
      (
      (
        1?\d?\d|  A single digit, two digits, or 100-199
        25[0-5]|  The numbers 250-255
        2[0-4]\d  The numbers 200-249
      )
      \.|$ the number must be followed by either a dot or end-of-string - to match the last number
      ){4} Expect exactly four of these
    \/   An escaped foward-slash delimiter for matching a cidr bitmask
    ([0-9]|[12][0-9]|3[0-2]) - the number 0-32
    $ end of string
    */
  if (
    !/^(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|\/)){4}([0-9]|[12][0-9]|3[0-2])$/.test(
      cidr
    )
  ) {
    //console.log(`CIDR '${cidr}' is formatted incorrectly`);
    return false;
  }
  const cidrParts = cidr.match(/\d+/g); // break CIDR into array of numbers
  const maskBits = cidrParts[4];
  const cidrIpHex = cidrParts.slice(0, 4).reduce((a: any, o: any) => {
    return unsignedNumber(+a << 8) + +o;
  });
  const cidrNetmask =
    maskBits > 0
      ? unsignedNumber(~0 << (32 - +maskBits))
      : unsignedNumber(1) - 1;
  let firstIpInCidr = hexToIp(unsignedNumber(cidrIpHex & cidrNetmask));
  firstIpInCidr = `${firstIpInCidr}/${cidrParts[4]}`;
  if (firstIpInCidr === cidr) {
    //console.log(`CIDR '${cidr}' is valid`)
    return true;
  } else {
    //console.log(`CIDR '${cidr}' is invalid, but could be represented as ${firstIpInCidr}`)
    return false;
  }
}
